import { ModalContext } from "app/app";
import { Icon } from "components/lib";
import { Field } from "formik";
import { useCallback, useContext } from "react";
import { useDropzone } from "react-dropzone";
import ReactSelect from "react-select";
import styles from "./styles.module.scss";

export function FieldInput(props) {
  const { modal } = useContext(ModalContext);

  const onDrop = useCallback((file) => {
    if (!document.getElementById(props.id)) return;

    var container = new DataTransfer();

    for (var i = 0; i < file.length; i++) {
      container.items.add(file[i]);
    }

    document.getElementById(props.id).files = container.files;
    props.handleChange(container);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <div className={styles.field}>
      {props.label && (
        <label htmlFor={props.id}>
          {props.label} {props.required && <span>*</span>}
        </label>
      )}

      {props.type === "text" && (
        <Field
          id={props.id}
          name={props.id}
          className={styles.input}
          placeholder={props.placeholder}
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          style={props.halfSize ? { width: "50%" } : { width: "100%" }}
          disabled={props.disabled}
        />
      )}

      {props.type === "text_with_value" && (
        <Field
          id={props.id}
          name={props.id}
          className={styles.input}
          placeholder={props.placeholder}
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          value={props.value}
          style={props.halfSize ? { width: "50%" } : { width: "100%" }}
          disabled={props.disabled}
        />
      )}

      {props.type === "multi_select" && (
        <ReactSelect
          isMulti
          name="policy"
          options={props.options}
          defaultValue={props.defaultValue}
          classNamePrefix="select"
          onChange={(event) => props.handleChange(event)}
          required
          isDisabled={props.isDisabled}
          styles={{
            container: (baseStyles, state) => ({
              ...baseStyles,
              width: "100%",
              minHeight: "50px",
              marginTop: "10px",
            }),
            control: (baseStyles, state) => ({
              ...baseStyles,
              width: "100%",
              minHeight: "50px",
              border: "solid 1.5px #e0e0e0",
              borderRadius: "10px",
            }),
          }}
        />
      )}

      {props.type === "phone" && (
        <Field
          id={props.id}
          name={props.id}
          className={styles.input}
          placeholder={props.placeholder}
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          value={props.value}
          style={props.halfSize ? { width: "50%" } : { width: "100%" }}
          disabled={props.disabled}
        />
      )}

      {props.type === "currency" && (
        <Field
          id={props.id}
          name={props.id}
          className={styles.input}
          placeholder={props.placeholder}
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          value={props.value}
          style={props.halfSize ? { width: "50%" } : { width: "100%" }}
          disabled={props.disabled}
        />
      )}

      {props.type === "date" && (
        <Field
          id={props.id}
          type="date"
          name={props.id}
          className={styles.input}
          placeholder={props.placeholder}
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          style={props.halfSize ? { width: "50%" } : { width: "100%" }}
          disabled={props.disabled}
        />
      )}

      {props.type === "number" && (
        <Field
          id={props.id}
          type="number"
          name={props.id}
          className={styles.input}
          placeholder={props.placeholder}
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          style={props.halfSize ? { width: "50%" } : { width: "100%" }}
          disabled={props.disabled}
        />
      )}

      {props.type === "area" && (
        <textarea
          id={props.id}
          name={props.id}
          className={styles.input}
          placeholder={props.placeholder}
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          rows="32"
          cols="50"
        />
      )}

      {props.type === "upload" && (
        <div className={styles.upload} {...getRootProps()} onClick={() => {}}>
          {isDragActive ? (
            <>
              <div className={styles.uploadIcon}>
                <Icon image="arrow-down-circle" color="#d32426" size={20} />
              </div>
              <span>Drop your file</span>
            </>
          ) : (
            <>
              <div className={styles.uploadIcon}>
                <Icon image="upload" color="#d32426" size={20} />
              </div>
              <span>
                {document.getElementById(props.id) &&
                  document.getElementById(props.id).files[0] && (
                    <>
                      <span>
                        Attached:{" "}
                        {document.getElementById(props.id).files[0].name}
                      </span>
                      <br />
                    </>
                  )}
                {modal.data && modal.data.link && (
                  <>
                    <span
                      style={{
                        color: "#637381",
                        textDecoration: "none",
                        cursor: "default",
                      }}
                    >
                      Attached: {modal.data.link.split("/")[3].split("-")[1]}{" "}
                      <span
                        style={{
                          textDecoration: "none",
                          cursor: "pointer",
                        }}
                        onClick={() => window.open(modal.data.link)}
                      >
                        - View file
                      </span>
                    </span>
                    <br />
                  </>
                )}
                {props.id === "front_license" &&
                  modal.data &&
                  modal.data.front_license_link && (
                    <>
                      <span
                        style={{
                          color: "#637381",
                          textDecoration: "none",
                          cursor: "default",
                        }}
                      >
                        Attached:{" "}
                        {
                          modal.data.front_license_link
                            .split("/")[3]
                            .split("-")[1]
                        }{" "}
                        <span
                          style={{
                            textDecoration: "none",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            window.open(modal.data.front_license_link)
                          }
                        >
                          - View file
                        </span>
                      </span>
                      <br />
                    </>
                  )}
                {props.id === "back_license" &&
                  modal.data &&
                  modal.data.back_license_link && (
                    <>
                      <span
                        style={{
                          color: "#637381",
                          textDecoration: "none",
                          cursor: "default",
                        }}
                      >
                        Attached:{" "}
                        {
                          modal.data.back_license_link
                            .split("/")[3]
                            .split("-")[1]
                        }{" "}
                        <span
                          style={{
                            textDecoration: "none",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            window.open(modal.data.back_license_link)
                          }
                        >
                          - View file
                        </span>
                      </span>
                      <br />
                    </>
                  )}
                Drag & drop or{" "}
                {(modal.data && modal.data.link && (
                  <span
                    onClick={() => {
                      var elem = document.getElementById(props.id);

                      if (elem) {
                        elem.click();
                      }
                    }}
                  >
                    change
                  </span>
                )) ||
                  (props.id === "front_license" &&
                    modal.data &&
                    modal.data.front_license_link && (
                      <span
                        onClick={() => {
                          var elem = document.getElementById(props.id);

                          if (elem) {
                            elem.click();
                          }
                        }}
                      >
                        change
                      </span>
                    )) ||
                  (props.id === "back_license" &&
                    modal.data &&
                    modal.data.back_license_link && (
                      <span
                        onClick={() => {
                          var elem = document.getElementById(props.id);

                          if (elem) {
                            elem.click();
                          }
                        }}
                      >
                        change
                      </span>
                    )) || (
                    <span
                      onClick={() => {
                        var elem = document.getElementById(props.id);

                        if (elem) {
                          elem.click();
                        }
                      }}
                    >
                      {" "}
                      browse
                    </span>
                  )}
              </span>
            </>
          )}
          <input
            type="file"
            id={props.id}
            name={props.id}
            onBlur={props.handleBlur}
            {...getInputProps()}
            style={{ display: "none" }}
          />
        </div>
      )}

      {props.type === "upload_multiple" && (
        <div className={styles.upload} {...getRootProps()} onClick={() => {}}>
          {isDragActive ? (
            <>
              <div className={styles.uploadIcon}>
                <Icon image="arrow-down-circle" color="#d32426" size={20} />
              </div>
              <span>Drop your file</span>
            </>
          ) : (
            <>
              <div className={styles.uploadIcon}>
                <Icon image="upload" color="#d32426" size={20} />
              </div>
              <span>
                {document.getElementById(props.id) &&
                  document.getElementById(props.id).files[0] && (
                    <>
                      <span>
                        Attached:{" "}
                        {document.getElementById(props.id).files[0].name +
                          ", and others " +
                          (document.getElementById(props.id).files.length - 1)}
                      </span>
                      <br />
                    </>
                  )}
                Drag & drop or{" "}
                <span
                  onClick={() => {
                    var elem = document.getElementById(props.id);

                    if (elem) {
                      elem.click();
                    }
                  }}
                >
                  browse
                </span>
              </span>
            </>
          )}
          <input
            type="file"
            id={props.id}
            name={props.id}
            multiple
            onBlur={props.handleBlur}
            onChange={props.handleChange}
            {...getInputProps()}
            style={{ display: "none" }}
          />
        </div>
      )}

      {props.type === "select" && (
        <Field
          id={props.id}
          name={props.id}
          as="select"
          className={styles.inputDropdown}
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          style={props.halfSize ? { width: "50%" } : { width: "100%" }}
        >
          {
            props.placeholder && (
              <option value="" disabled selected>
                {props.placeholder}
              </option>
            )
          }
          {props.options.map((option, index) => {
            return (
              <option value={option.value} label={option.label} key={index} />
            );
          })}
        </Field>
      )}

      {props.type === "search_select" && (
        <ReactSelect
          id={props.name}
          name={props.name}
          options={props.options}
          defaultValue={props.defaultValue}
          value={props.value}
          classNamePrefix="select"
          isSearchable
          onChange={(event) => props.handleChange(event)}
          required
          isDisabled={props.disabled}
          placeholder={props.placeholder}
          styles={{
            container: (baseStyles, state) => ({
              ...baseStyles,
              width: "100%",
              height: "58px",
              marginTop: "10px",
            }),
            control: (baseStyles, state) => ({
              ...baseStyles,
              width: "100%",
              height: "58px",
              border: "solid 1.5px #e0e0e0",
              borderRadius: "5px",
            }),
          }}
        />
      )}

      {props.showErrors && (
        <div
          className={styles.error}
          style={
            props.errors && props.touched ? { opacity: 100 } : { opacity: 0 }
          }
        >
          <div className={styles.icon}>
            <Icon image="alert-circle" size={10} />
          </div>
          {props.errors}
        </div>
      )}
    </div>
  );
}
